import { createContext } from 'react';
import { Suggestion, SuggestionGroup } from 'js/social/shared/types';

export type SuggestionsContextValue = {
  groups: SuggestionGroup[];
  count: number;
  hasMore: boolean;
  isLoading: boolean;
  refresh: () => void;
  getGroup: (groupId: string | null) => SuggestionGroup | null;
  getRandomGroupId: (minSuggestions: number) => string | null;
  getFirstPriorityGroupId: (minSuggestions: number) => string | null;
  getSuggestions: (groupId: string, count: number) => Suggestion[];
};

export const SuggestionsContext = createContext<SuggestionsContextValue>({
  groups: [],
  count: 0,
  hasMore: false,
  isLoading: false,
  refresh: () => null,
  getGroup: () => null,
  getRandomGroupId: () => '',
  getFirstPriorityGroupId: () => null,
  getSuggestions: () => [],
});
